module.exports = __webpack_public_path__ + "img/GG_LOGO_HEADER.655cebdd.svg";